import { useChat } from '../contexts/ChatContext'
import Sidebar from './Sidebar'
import MessagesArea from './MessagesArea'
import MessageInput from './MessageInput'
import ModeToggle from './ModeToggle'
import ProgressChips from './ProgressChips'
import ErrorBanner from './ErrorBanner'
import NewsBanner from './NewsBanner'

export default function ChatInterface() {
  const { sidebarCollapsed, setSidebarCollapsed } = useChat()

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Floating Mobile Menu Button - Top Left */}
      {sidebarCollapsed && (
        <button
          onClick={() => setSidebarCollapsed(false)}
          className="lg:hidden fixed top-4 left-4 z-50 w-12 h-12 bg-primary text-primary-foreground rounded-full shadow-xl flex items-center justify-center hover:bg-primary/90 active:scale-95 transition-all duration-150"
          aria-label="Open menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      )}

      {/* Main Chat Area */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* News Banner */}
        <NewsBanner />

        {/* Error Banner */}
        <ErrorBanner />

        {/* Mode Toggle */}
        <ModeToggle />

        {/* Messages Area */}
        <div className="flex-1 overflow-hidden">
          <MessagesArea />
        </div>

        {/* Progress Chips */}
        <ProgressChips />

        {/* Disclaimer */}
        <div className="text-center px-8 py-2 bg-background text-xs text-muted-foreground italic">
          تنبيه: قد يخطئ AIlex ولا يُعد بديلاً عن الاستشارة القانونية الرسمية.
        </div>

        {/* Message Input */}
        <MessageInput />
      </div>

      {/* Sidebar */}
      <Sidebar />

      {/* Sidebar Overlay for Mobile */}
      {!sidebarCollapsed && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarCollapsed(true)}
        />
      )}
    </div>
  )
}
